import React from 'react';

export default function ErrorInputMessage({
  show,
  message = 'Error',
  classes = '',
}) {
  return show && <span className={`error-message ${classes}`}>{message}</span>;
}
